import { buildEvaluationURLObject, buildEvaluationByLocalityURLObject } from '../links';

export function buildBreadcrumb(locality?: string) {
  const evaluationURLObject = buildEvaluationURLObject();

  if (locality) {
    const evaluationByCityURLObject = buildEvaluationByLocalityURLObject({ locality });

    return [{
      label: 'Valutazione immobile',
      urlObject: evaluationURLObject,
    }, {
      label: locality,
      urlObject: evaluationByCityURLObject,
    }];
  }

  return [{
    label: 'Valutazione immobile',
    urlObject: evaluationURLObject,
  }];
}

export default buildBreadcrumb;
